// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__eLB1N","left":"StickyBox_left__1pjBM","right":"StickyBox_right__dd_dB"};